module.exports = __webpack_public_path__ + "images/category_lp/audio_instrument/new/store_images/5_6a77517b837b2cee0ac23b2a6dea3c33.png";